import React, { useState } from 'react'
import { Input, InputProps } from './ui/Input'
import { Button } from './ui/button'
import { EyeIcon } from '@heroicons/react/16/solid'

const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    const [showPassword, setShowPassword] = useState(false)
    return (
      <Input
        {...props}
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        trailingIcon={
          <Button
            type="button"
            iconOnly
            size="sm"
            variant="ghost"
            className="hover:bg-transparent hover:text-txt-primary"
            onTouchStart={() => setShowPassword(true)}
            onTouchEnd={() => setShowPassword(false)}
            onMouseDown={() => setShowPassword(true)}
            onMouseUp={() => setShowPassword(false)}
            onMouseLeave={() => setShowPassword(false)}
            onTouchCancel={() => setShowPassword(false)}
            onTouchMove={() => setShowPassword(false)}
          >
            <EyeIcon className="size-6" />
          </Button>
        }
      />
    )
  },
)

export { PasswordInput }
